module.exports = __webpack_public_path__ + "static/kids-d989d66405c4f86f8d7d4e406c9d143a.jpg";